import React, { useEffect, useState } from 'react';
import Layout from '../../../components/Layout/Layout';
import LCDashboard, { Card } from '../../../components/Data/Dashboard/LCDashboard';
import { RiExternalLinkLine } from 'react-icons/ri';
import LcLoading from '../../../components/Generic/LcLoading';
import LcNoData from '../../../components/Generic/LcNoData';
import IconValue from '../../../components/Layout/Dashboard/IconValue';
import { useHistory } from 'react-router-dom';
import { FiMonitor } from 'react-icons/fi';
import { HiOutlineRefresh } from 'react-icons/hi';
import { RxExclamationTriangle } from 'react-icons/rx';
import { PiLinuxLogo, PiPackageBold } from 'react-icons/pi';
import InstalledVsMissingGraph from './InstalledVsMissingGraph';
import MissingPatchesGraph from './MissingPatchesGraph';
import SystemsByPlatformGraph from './SystemsByPlatformGraph';
import PPDropDown from '../../../components/PPDropDown';
import { PatchManagerService } from '../../../services/patchmanager/patchManagerService';
import { GraphModel, MissingPatches, PatchDataModel, PatchDatailModel, PatchModel, SystemByPlataformList, SystemModel } from '../../../services/patchmanager/patchManagerModel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { UserState } from '../../../store/reducers/userReducer';
import LcInfiniteTable from '../../../components/Data/LcInfiniteTable';
import moment from 'moment';
import { AiOutlineWindows, AiOutlineApple, AiOutlineExclamationCircle, AiOutlineCheckCircle } from 'react-icons/ai';
import LcIconLink from '../../../components/Generic/LcIconLink';
import LcTooltip from '../../../components/Generic/LcTooltip';
import { LiaBanSolid } from 'react-icons/lia';


const ResumePathManager: React.FC = (props) => {

    const user = useSelector<RootState, UserState>(state => state.user);
    const patchManagerService = new PatchManagerService(props);
    const [loading, setLoading] = useState<boolean>(false);
    const history = useHistory();
    const [SystemPlataformOpt, setSystemPlataformOpt] = useState([{ label: 'Suportados', value: 1 }, { label: 'Obsoletos', value: 2 }])
    const [systemPlataformSelected, setSystemPlataformSelected] = useState(1);
    const [patchesData, setPatchesData] = useState<PatchModel>()
    const [patchSummariesResume, setPatchSummariesResume] = useState<GraphModel[]>()
    const [systemData, setSystemData] = useState<SystemModel>()
    const [systemList, setSystemList] = useState<SystemByPlataformList[]>([]);
    const [systemRebootRequired, setSystemRebootRequired] = useState<SystemByPlataformList[]>([])
    const [systemAgentOff, setSystemAgentOff] = useState<SystemByPlataformList[]>([])
    const [systemCriticalPatches, setSystemCriticalPatches] = useState<SystemByPlataformList[]>([])
    const [systemFailurePatches, setSystemFailurePatches] = useState<SystemByPlataformList[]>([])

    const calculateSeveritySum = (data: MissingPatches[]) => {
        const severityCounts = {
            critical: 0,
            important: 0,
            moderate: 0,
            low: 0,
            unclassified: 0,
        };

        data.forEach((item) => {
            const severity = item.severity;

            if (severityCounts.hasOwnProperty(severity)) {
                severityCounts[severity]++;
            } else {
                severityCounts.unclassified++;
            }
        });

        return severityCounts;
    }

    const columnsSystem = [
        {  field: "agentStatus", headerName: "", width: "10px", align: 'right',
            renderCell: (row: SystemByPlataformList) => <div style={{ width: '3px', height: '25px', borderRadius: '10px', backgroundColor: row.agentStatus === 'on' ? '#3ebb3f' : '#dc291e' }}></div>
        },
        { field: "hostName", headerName: "HostName", width: "15%", align: 'left', fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '-6px' }}>
                        <LcIconLink icon={
                            row.operationalSystem.toLocaleLowerCase().includes('windows') ? <AiOutlineWindows size={'1rem'} />
                                :
                                row.operationalSystem.toLocaleLowerCase().includes('mac') ? <AiOutlineApple size={'1rem'} />
                                    :
                                    <PiLinuxLogo size={'1rem'} />
                        } />
                        <span style={{ fontWeight: 600 }} className='font-4x'>{row.hostName}</span>
                    </div>
                )
            }
        },
        { field: "agentStatus", headerName: "Status do agente", width: "12%", align: 'center', fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return row.agentStatus === 'on' ?
                    <div style={{ width: '10px', height: '10px', borderRadius: '100%', backgroundColor: '#3ebb3f' }}></div>
                    :
                    <div style={{ width: '10px', height: '10px', borderRadius: '100%', backgroundColor: '#dc291e' }}></div>
            } 
        }, 
        { field: "lastCommunication", headerName: "Última comunicação", width: "15%", align: 'left', fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return moment(row.lastCommunication).format('DD/MM/YYYY hh:mm')
            }
        },
        { field: "rebootRequired", headerName: "Reboot necessário", width: "15%", align: 'center', overflow: "visible", fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return row.rebootRequired &&
                    <LcIconLink size='small'
                        icon={<AiOutlineExclamationCircle color='#ffb530' size={18} />}
                        tooltip="Necessário reiniciar a máquina"
                        tooltipPosition='right'

                    />
            }
        },
        { field: "operational_System", headerName: "Sistema Operacional", width: "27%", align: 'left', overflow: 'visible', fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return row.legacySystem ?
                    <div className='operationalSystem'>
                        <p>{row.operationalSystem}</p>
                        <LcIconLink size='small'
                            icon={<AiOutlineExclamationCircle color='#ffb530' fontSize={'1rem'} />}
                            tooltip="Sistema legado"
                            tooltipPosition='left'
                        />
                    </div>
                    :
                    <div className='operationalSystem'>{row.operationalSystem}</div>
            }
        } 
    ];
     
    const columnsPatches = [
        { field: "patchId", headerName: "Patch ID", width: "8%", align: 'center', },
        { field: "severity", headerName: "Severidade", width: "15%", align: 'center',
            renderCell: (row: PatchDataModel) => {
                return <div className='severityLabelDetails' style={{
                    padding: '0px 8px',
                    backgroundColor: translateSeverityColor(row.severity)
                }}>
                    {translateSeverityLabel(row.severity)}
                </div>
            }
        }, 
        { field: "kbNumber", headerName: "Número KB", width: "10%", align: 'left' },
        { field: "patchDescription", headerName: "Descrição do patch", width: "35%", align: 'left',
            renderCell: (row: PatchDataModel) => <div className='overflowEllipsis'>{row.patchDescription}</div>
        },
        { field: "approveStatus", headerName: "Status de aprovação", width: "12%", align: 'center',
            renderCell: (row: PatchDataModel) => {
                return <div style={{ display: 'flex', alignItems: 'center', marginLeft: row.approveStatus === 'Reproved' ? '-6px' : '-10px' }} >
                    <LcIconLink icon={row.approveStatus === 'Reproved' ? <LiaBanSolid color='#dc291e' /> : <AiOutlineCheckCircle color='#3ebb3f' />} />
                    <span className={'ml-5'}>{translateApprovalStatus(row.approveStatus)}</span>
                </div>
            }
        }, 
        { field: "platform", headerName: "Plataforma", width: "10%", align: 'left',
            renderCell: (row: any) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '-6px' }}>
                        {row.platform && <LcIconLink icon={
                            row.platform.includes('Windows') ? <AiOutlineWindows size={'1rem'} />
                                :
                                row.platform.includes('mac') ? <AiOutlineApple size={'1rem'} />
                                    :
                                    <PiLinuxLogo size={'1rem'} />
                        } />}
                        <span>{row.platform}</span>
                    </div>
                )
            }
        },
        { field: "rebootRequired", headerName: "Reboot", width: "10%", align: 'center', overflow: "visible",
            renderCell: (row: any) => {
                return row.rebootRequired != "0" ?
                    <LcIconLink size='small'
                        icon={<AiOutlineExclamationCircle color='#ffb530' size={18} />}
                        tooltip="Necessário reiniciar a máquina"
                        tooltipPosition='right'

                    /> : <div>-</div>
            }
        },
    ];
     
    const GetPatchSummariesResume = async () => { 
        try {
            const patchesResponse = await patchManagerService.GetPatchSummariesResume();
           // patchesResponse.filter(c => c.name == 'Patches')[0]
            setPatchSummariesResume(patchesResponse)
        } catch (error) {
            console.error('Error:', error);
        }
    }
      
    const getSystemRebootRequired = (data: SystemByPlataformList[]) => {
        let reboot_Required = data.filter(filter => filter.rebootRequired === true);
        let agent_Off = data.filter(filter => filter.agentStatus === 'off');
        let critical_patches = data.filter(patch => patch.missingPatches.some(miss => miss.severity.toLowerCase() === 'critical'));
        let failure_patches = data.filter(patch => patch.missingPatches.some(miss => miss.status.toLowerCase() === 'failure'));

        return { reboot_Required, agent_Off, critical_patches, failure_patches }
    }

    useEffect(() => {
        setLoading(true);
        Promise.all([
            GetPatchSummariesResume()
        ]).finally(() => setLoading(false));
    }, [user.ClientGroupSelected, user.refreshFlag]);

    const tranleteStatusColorRow = (status: PatchDataModel) => {
        const tranlateStatusColor = {
            'Important': '#ffa400',
            'Critical': "#dc291e",
            'High': "#dc291e",
            'Moderate': "#f6de00",
            'Medium': '#f6de00',
            'Low': "#3ebb3f",
            'Unclassified': "#cccccf",
        };
        return tranlateStatusColor[status.severity];
    }
    const tranleteStatusColorRowDetails = (status: PatchDatailModel) => {
        const tranlateStatusColor = {
            'Important': '#ffa400',
            'Critical': "#dc291e",
            'High': "#dc291e",
            'Medium': "#f6de00",
            'Moderate': "#f6de00",
            'Low': "#3ebb3f",
            'Unclassified': "#cccccf",
        };
        return tranlateStatusColor[status.patch_serverity];
    }
    const translateStatusColor = (status: string) => {
        const tranlateStatusColor = {
            'Important': '#ffa400',
            'Critical': "#dc291e",
            'High': "#dc291e",
            'Moderate': "#f6de00",
            'Medium': '#f6de00',
            'Low': "#3ebb3f",
            'Unclassified': "#cccccf",
        };
        return tranlateStatusColor[status];
    }
    const translateSeverityColor = (status: string) => {
        const tranlateStatusColor = {
            '4': '#ff4400', // 'Important'
            '3': '#ffa400', // 'Important'
            '2': "#f6de00",// 'Moderate' 
            '1': "#3ebb3f",//'Low'
            '0': "#cccccf",//'Unrated'
        };
        return tranlateStatusColor[status];
    }
    const translateSeverityLabel = (status: string) => {
        const tranlateStatusColor = {
            '4': 'Crítico'
            , '3': 'Important'
            , '2': 'Moderate'
            , '1': 'Low'
            , '0': 'Unrated'
        };
        return tranlateStatusColor[status];
    }

    const translateStatusLabel = (status: string) => {
        const tranleteStatusLabel = {
            'Important': 'Importante',
            'High': 'Alta',
            'Medium': 'Media',
            'Critical': "Crítico",
            'Moderate': "Moderado",
            'Low': "Baixo",
            'Unclassified': "Não Classificado",
        };
        return tranleteStatusLabel[status];
    }
    const translateStatusPatch = (status: string) => {
        const translateStatus = {
            '202': 'Ausente',
            '201': "Instalado",
            '206': "Falha"
        };
        return translateStatus[status];
    }
    const translateApprovalStatus = (status: string) => {
        const tranleteStatus = {
            'Approved': 'Aprovado',
            'Reproved': "Reprovado",

        };
        return tranleteStatus[status];
    }


    const cards: Card[] = [{
        id: 1, //Patchs críticos
        type: 'Custom', position: { ColSpan: 2, RowSpan: 1, row: 1, col: 1 },
        showFocusButton: true,
        title: () => "Patches críticos",
        customContentRender: (focused: boolean) => {
            if (focused) {
                return (patchSummariesResume ? <LcInfiniteTable 
                        rows={patchSummariesResume.filter(c => c.name == 'Criticos')[0].list as object[]}
                        columns={columnsPatches}
                        loadMore={() => undefined}
                        size={systemCriticalPatches.length}
                        hidePagination
                    />:<></>
                )
            } else {
                return (
                    <LcLoading loading={loading} label="Carregando patches...">
                        {
                            patchSummariesResume ?
                                <>
                                    <IconValue
                                        icon={<RxExclamationTriangle size={'1.8rem'} />}
                                        value={patchSummariesResume.filter(c => c.name =='Criticos')[0].value}
                                        color="#e0443a"
                                        description='Ausentes'
                                        cssClass='font-xl'
                                    />
                                </>
                                :
                                <LcNoData size="small" />
                        }
                    </LcLoading>

                )
            }
        }
    },
    {
        id: 2, //com falhas
        type: 'Custom', position: { ColSpan: 2, RowSpan: 1, row: 1, col: 3 },
        showFocusButton: true,
        title: () => "Patches com falhas",
        customContentRender: (focused: boolean) => {
            if (focused) {
                return (
                    patchSummariesResume ? <LcInfiniteTable 
                        rows={patchSummariesResume.filter(c => c.name == 'Falhas')[0].list as object[]}
                        columns={columnsPatches}
                        loadMore={() => undefined}
                        size={systemFailurePatches.length}
                        hidePagination
                    />:<></>
                )
            } else {
                return (
                    <LcLoading loading={loading} label="Carregando patches...">
                        {
                            patchSummariesResume ?
                                <>
                                    <IconValue
                                        icon={<RxExclamationTriangle size={'1.8rem'} />}
                                        value={patchSummariesResume.filter(c => c.name == 'Falhas')[0].value}
                                        color="#ffb530"
                                        description='Sistemas'
                                        cssClass='font-xl'
                                    />
                                </>
                                :
                                <LcNoData size="small" />
                        }
                    </LcLoading>
                )
            }
        }
    },
    {
        id: 3, //Agentes
        type: 'Custom', position: { ColSpan: 2, RowSpan: 1, row: 1, col: 5 },
        showFocusButton: true,
        title: () => "Agentes",
        customContentRender: (focused: boolean) => {
            if (focused) {
                return (
                    patchSummariesResume ? <LcInfiniteTable
                        rows={patchSummariesResume.filter(c => c.name == 'Agentes')[0].list as object[]}
                        columns={columnsSystem}
                        loadMore={() => undefined}
                        size={systemFailurePatches.length}
                        hidePagination
                    /> :<></> 
                )
            } else {
                return (
                    <LcLoading loading={loading} label="Carregando Agentes...">
                        {
                            patchSummariesResume ?
                                <>
                                    <IconValue
                                        icon={<RxExclamationTriangle size={'1.8rem'} />}
                                        value={patchSummariesResume.filter(c => c.name == 'Agentes')[0].value}
                                        color="#e0443a"
                                        description='Desconectados'
                                        cssClass='font-xl'
                                    />
                                </>
                                :
                                <LcNoData size="small" />
                        }
                    </LcLoading>

                )
            }
        }
    },
    {
        id: 4, //Reboot Pendente
        type: 'Custom', position: { ColSpan: 2, RowSpan: 1, row: 1, col: 7 },
        showFocusButton: true,
        title: () => "Reboot pendente",
        customContentRender: (focused: boolean) => { 
            if (focused) {
                return (
                    patchSummariesResume ?  <LcInfiniteTable
                        rows={patchSummariesResume.filter(c => c.name == 'RebootPendente')[0].list as object[]}
                        columns={columnsSystem}
                        loadMore={() => undefined}
                        size={systemRebootRequired.length}
                        hidePagination
                    />:<></>
                )
            } else {
                return (
                    <LcLoading loading={loading} label="Carregando reboots...">
                        {
                            patchSummariesResume ?
                                <>
                                    <IconValue
                                        value={patchSummariesResume.filter(c => c.name == 'RebootPendente')[0].value}
                                        icon={<HiOutlineRefresh size={'1.8rem'} />}
                                        color="#ffb530"
                                        description='Sistemas'
                                        cssClass='font-xl'
                                    />
                                </>
                                :
                                <LcNoData size="small" />
                        }
                    </LcLoading>

                )
            }
        }
    },
    {
        id: 5, //Sistemas
        type: 'Custom', position: { ColSpan: 4, RowSpan: 1, row: 1, col: 9 },
        ticketButton: () => { return <RiExternalLinkLine onClick={() => { history.push('/patchmanager/systems') }} /> },
        showFocusButton: false,
        title: () => "Sistemas",
        customContentRender: () => {
            return (
                <LcLoading loading={loading} label="Carregando sistemas...">
                    {
                        patchSummariesResume ?
                            <>
                                <IconValue
                                    value={patchSummariesResume.filter(c => c.name == 'Systems')[0].value}
                                    color="#141b4d"
                                    icon={<FiMonitor size={'1.8rem'} />}
                                    description='Gerenciados'
                                    cssClass='font-xl'
                                />
                            </>
                            :
                            <LcNoData size="small" />
                    }
                </LcLoading>

            )
        }
    },
    {
        id: 6, //Patchs
        type: 'Custom', position: { ColSpan: 4, RowSpan: 1, row: 2, col: 1 },
        showFocusButton: false,
        ticketButton: () => { return <RiExternalLinkLine onClick={() => { history.push('/patchmanager/patches') }} /> },
        title: () => "Patches",
        customContentRender: () => {
            return (
                <LcLoading loading={loading} label="Carregando patches...">
                    {
                        patchSummariesResume ?
                            <>
                                <IconValue
                                    icon={<PiPackageBold size={'1.8rem'} />}
                                    value={patchSummariesResume.filter(c => c.name == 'Patches')[0].value}
                                    color="#141b4d"
                                    description='Implantados em seu ambiente'
                                    cssClass='font-xl'
                                />
                            </>
                            :
                            <LcNoData size="small" />
                    }
                </LcLoading>

            )
        }
    },
    {
        id: 7, //Patches instalados vc ausentes
        type: 'Custom', position: { ColSpan: 4, RowSpan: 3, row: 3, col: 1 },
        showFocusButton: false,
        title: () => "Patches instalados vc ausentes",
        customContentRender: () => <InstalledVsMissingGraph />
    },
    {
        id: 8, //Patches ausentes
        type: 'Custom', position: { ColSpan: 4, RowSpan: 4, row: 2, col: 5 },
        showFocusButton: false,
        title: () => "Patches ausentes",
        customContentRender: () => <MissingPatchesGraph />
    },
    {
        id: 8, //Sistemas por Plataforma
        type: 'Custom', position: { ColSpan: 4, RowSpan: 4, row: 2, col: 9 },
        showFocusButton: false,
        title: () => {
            return <>
                {
                    <div className={'lc-segment-title-row-resume'} style={{ alignItems: 'flex-end' }}>
                        <div className={'lc-title ellipsis'}>Sistemas por Plataforma</div>
                        <PPDropDown
                            name='rankType'
                            options={SystemPlataformOpt}
                            defaultValue={SystemPlataformOpt.find(option => option.value == systemPlataformSelected)}
                            value={SystemPlataformOpt.find(option => option.value == systemPlataformSelected)}
                            onChange={(event) => setSystemPlataformSelected(event.value)}
                            width='128px'
                        />
                    </div>
                }</>
        },
        customContentRender: () => <SystemsByPlatformGraph selected={systemPlataformSelected} />
    }];

    return (
        <Layout pageTitle='Resumo'>
            <LCDashboard cards={cards} /> 
        </Layout>
    );
}

export default ResumePathManager;